

import { useContext, useEffect, useState } from 'react'


import 'bootstrap-daterangepicker/daterangepicker.css';

import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../../components/hooks/useForm';
import Message from '../../components/ui/Message';
import { LoyaltyContext } from '../../context/loyalty/LoyaltyContext';
import { useRequiredFields } from '../../hooks/useRequiredFields';




export const RewardPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [isFormValid, setIsFormValid] = useState(false);
    const { addReward, updateReward } = useContext(LoyaltyContext);
    const [errorMessage, setErrorMessage] = useState('');
    const required = useRequiredFields();
    const [successMessage, setSuccessMessage] = useState('');
    const [services, setServices] = useState([]);

    var reward;

    if (state) {
        reward = state.reward;
    } else {
        reward = {
            id: -1,
            recompensa: '',
            requiere: ''
        }
    }


    const { formState, onInputChange } = useForm(reward);

    const { id, recompensa, requiere } = formState






    const handleSave = async () => {

        const formValid = recompensa.length > 0 && requiere != "" && parseInt(requiere) > 0

        if (!formValid) {
            required.fail();
            setErrorMessage("Debe completar los campos requeridos.");
            return false;
        }

        var resp = "";
        if (id > 0) {
            resp = await updateReward(formState);
        } else {
            resp = await addReward(formState);
        }
        if (resp == "success") {
            setSuccessMessage(id > 0 ? "Recompensa actualizada correctamente" : "Recompensa creada correctamente.");
        } else {
            setErrorMessage(resp);
        }
    }

    const removeError = () => {
        setErrorMessage('');
    }

    const removeSucessMessage = () => {
        setSuccessMessage('');
        navigate(-1);
    }

    return (

        <div className='container d-flex align-items-center justify-content-center mt-5' style={styles.container}>


            <div className='col-md-6'>
                <h3>{id > 0 ? 'Actualizar recompensa' : 'Crear recompensa'}</h3>
                <hr />

                <form className="row g-3 " >





                    <div className="mb-3">
                        <label htmlFor="rewardInput" className="form-label">Recompensa *</label>
                        <input
                            id='rewardInput'
                            type="text"
                            className={`form-control${required.mark(!recompensa)}`}
                            placeholder="Recompensa"
                            name="recompensa"
                            value={recompensa}
                            onChange={onInputChange}
                            required
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="requiredInput" className="form-label">Puntos requeridos *</label>
                        <input
                            id='requiredInput'
                            type="number"
                            className={`form-control${required.mark(!(parseInt(requiere) > 0))}`}
                            placeholder="Puntos requeridos"
                            name="requiere"
                            value={requiere}
                            onChange={onInputChange}
                            required
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>




                    <div className='container d-flex align-items-center justify-content-center mt-5'>
                        <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">Atrás</button>

                        <button type="button" onClick={handleSave} className="btn btn-primary ms-5" >Guardar</button>
                    </div>
                </form>
                <div style={{ height: '100px' }}></div>
            </div>
            {
                errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }
            {
                successMessage.length > 0 ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }



        </div>
    )
}


const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
